import { GRAPHQL_URL } from "../../constants";
import { fetch } from "../../index";
import { transformAllContentItems } from "../../../../utils/dataTransform/library";
import {
    formatHeadlines,
    maybeOverrideCategorySlug,
} from "../../../../utils/dataTransform/utils";
import query, { norm } from "../../queries";
import {
    allContentItems,
    localSubject as localSubjectQuery,
} from "../../queries/allContentItems";
import {
    getCategorySlug,
    getLineupSlug,
    getSubjectsSet,
    getTags,
} from "../../../../utils/path/library";

const section = (obj) => {
    const { section, itemCount } = obj;
    const lineupSlug = getLineupSlug(section);
    const subjectsSet = getSubjectsSet(section);
    const tags = getTags(section);
    const categorySlug = maybeOverrideCategorySlug(
        section,
        getCategorySlug(section)
    );
    const alias = norm(section);
    const query = allContentItems(
        alias,
        lineupSlug,
        categorySlug,
        itemCount,
        subjectsSet,
        "",
        "",
        tags
    );
    const response = formatSection(alias, section);
    return {
        query,
        response,
        section: section,
    };
};

const formatSection = (alias, section) => (data) => {
    const lineup = data[alias];
    if (lineup && lineup.nodes) {
        formatHeadlines(section, lineup.nodes);
        return transformAllContentItems(lineup.nodes);
    }
    return null;
};

const formatLocalSubject = (alias) => (data) => {
    const lineup = data[alias];
    if (lineup && lineup.nodes) {
        return transformAllContentItems(lineup.nodes);
    }
    return null;
};

const localSubject = (obj) => {
    const alias = norm(obj.section);
    return {
        query: localSubjectQuery(
            alias,
            obj.slug,
            obj.subjects,
            obj.itemCount,
            obj.excludedCategorySet
        ),
        response: formatLocalSubject(alias),
        section: obj.section,
    };
};

const getSwimlaneList = (swimlaneList) => {
    return swimlaneList.map((item) => {
        switch (item.type) {
            case "localSubject":
                return localSubject(item);
            default:
                return section(item);
        }
    });
};

/**
 * The DefaultSwimLane Object is used for creating http requests to allContentItems.
 * @typeDef {Object} DefaultSwimlane
 * @property {string} section - The section pathname is used for looking up the slug, and other query params.
 * @property {number} itemCount - The number of items to get.
 */

/**
 * The LocalSubjectSwimLane Object is used for creating http requests to allContentItems.
 * @typeDef {Object} LocalSubjectSwimlane
 * @property {string} [type=localSubject] - Defines the object as a LocalSubjectSwimlane.
 * @property {string] section - The section pathname.
 * @property {string] slug - The local regional slug.
 * @property {string} subjects - The Polopoly subjects tag.
 * @property {number} itemCount - The number of items to get.
 */

/**
 * The default function, requests a list of items, via graphql.
 * @param {Array.<DefaultSwimlane,LiveVideoSwimlane,LocalSubjectSwimlane>} swimlaneList - An array of ,.    .
 * @return Promise.<Array.<{response:Object,{query:Object},{section:string},{type?:string} }> -
 * A Promise List of Swim Lane Response Objects.
 */

export default function fetchSwimLaneList(swimlaneList) {
    const swimlaneQueryList = getSwimlaneList(swimlaneList);

    const queryObj = query(swimlaneQueryList.map((it) => it.query));

    if (!queryObj) {
        Promise.resolve([]);
    }

    return fetch(GRAPHQL_URL, queryObj, false).then((res) => {
        return swimlaneQueryList
            .map((it) => {
                it.response = it.response(res.data);
                return it;
            })
            .filter((it) => Boolean(it.response));
    });
}
